module.exports = __webpack_public_path__ + "img/4_161.dc8a7d38.png";